export function VideocamSharp() {
  return <path fill="currentColor" d="M2 20V4h16v6.5l4-4v11l-4-4V20z"></path>
}
